var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178,
    height: 221,
    viewBox: "0 0 178 221",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 32.95,34.41 L 178,1.5 V 203.26 C 176.98,212.06 171.18,218.91 162.24,219.4 H 90.74 L 78.83,219.17 L 126.61,154.65 C 129.11,151.06 129.25,145.91 129.19,140.32 V 63.82 C 129.19,60.42 124.82,56.41 121.79,56.41 L 94.28,56.53 C 89.21,56.38 86.06,60.91 86.06,63.82 V 154.23 L 32.95,186.63 V 34.41 Z",
    fill: "url(#paint0_linear_502_1173)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 177.42,1.7 L 33.53,34.73 V 36.1 L 137.09,17.63 L 161.78,24.16 L 158.19,37.96 L 161.42,42.9 L 158.72,47.91 L 162.24,57.4 L 148.81,62.41 L 147.25,77.21 L 153.93,82.74 L 146.09,92.89 L 147.99,104.87 L 156.97,100.6 L 155.78,124.01 L 147.25,130.76 L 151.28,137.86 L 159.44,137.04 L 157.27,153.17 L 146.67,164.74 L 149.07,176.94 L 155.78,177.87 L 153.08,186.93 L 151.28,191.13 L 155.47,197.27 L 160.68,200.71 L 168.16,194.11 L 170.56,207.6 L 165.42,217.69 C 173.7,215.28 177.21,208.18 177.53,202.71 L 177.42,1.7 Z",
    fill: "url(#paint1_linear_502_1173)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,219.17 L 128.91,140.41 C 128.91,145.73 127.81,150.98 125.89,153.95 L 78.76,219.34 L 29.18,219.17 H 16.92 L 0,219.4 V 219.17 Z",
    fill: "url(#paint2_linear_502_1173)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_1173",
    x1: 105.473,
    y1: 1.5,
    x2: 105.473,
    y2: 219.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D304A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16283D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_1173",
    x1: 105.525,
    y1: 17.626,
    x2: 105.525,
    y2: 217.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16283C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_1173",
    x1: 64.4541,
    y1: 140.406,
    x2: 64.4541,
    y2: 219.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC3E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0493972362e930e50f8f2344711195b4.svg";
export { ForwardRef as ReactComponent };